import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import type { Promocode } from "@shared/types/schema";

interface PurchaseDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  price: number;
  loading?: boolean;
  promocode?: Promocode;
}

export function PurchaseDialog({
  open,
  onOpenChange,
  onConfirm,
  price,
  loading,
  promocode,
}: PurchaseDialogProps) {
  const getDiscountedPrice = () => {
    if (!promocode) return price;

    if (promocode.isPercentage) {
      const discount = price * (promocode.discountAmount / 100);
      return Math.max(0, price - discount);
    } else {
      return Math.max(0, price - promocode.discountAmount);
    }
  };

  const discountedPrice = getDiscountedPrice();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="user-layout" aria-describedby="">
        <DialogHeader>
          <DialogTitle>Покупка игры</DialogTitle>
          <DialogDescription>
            {promocode ? (
              <div className="space-y-2">
                <p>Применён промокод: {promocode.code}</p>
                <p className="flex items-center gap-2">
                  <span className="line-through text-muted-foreground">
                    {price} ₽
                  </span>
                  <span className="font-semibold">{discountedPrice} ₽</span>
                </p>
              </div>
            ) : (
              <div>
                <p>Стоимость: {price} ₽</p>
                <p className="text-xs">
                  Временно принимаются только российские карты
                </p>
              </div>
            )}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end">
          <Button
            onClick={onConfirm}
            disabled={loading}
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            {loading ? "Обработка..." : "Купить"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
